module.exports = __webpack_public_path__ + "static/media/icon04.be86a958.png";